import moment from 'moment';

// Constants
export const CLEAN_DASHBOARD = 'DASHBOARD__CLEAN';
export const SET_DASHBOARD_INFO = 'DASHBOARD__SET_DASHBOARD_INFO';
export const SET_REFRESHING_DASHBOARD = 'DASHBOARD__SET_REFRESHING_DASHBOARD';
export const SET_ARCOS = 'DASHBOARD__SET_ARCOS';

const initialState = {
  fecha: null,
  arcos: [],
  lecturas: [],
  anomalias: [],
  registrosAnomalias: [],
  refreshingDashboard: true,
};

// Action handlers
const clean = () => ({ ...initialState });
const setRefreshingDashboard = (state, refreshingDashboard) => ({ ...state, refreshingDashboard });
const setDashboardInfo = (
  _,
  {
    arcos = [],
    lecturas = [],
    anomalias = [],
    registrosAnomalias = [],
  },
) => ({
  refreshingDashboard: false,
  fecha: moment(new Date()).format(),
  arcos,
  lecturas,
  anomalias,
  registrosAnomalias,
});

const setArcos = (state, arcos = []) => ({ ...state, arcos });

const ACTION_HANDLER = {
  [CLEAN_DASHBOARD]: clean,
  [SET_DASHBOARD_INFO]: setDashboardInfo,
  [SET_REFRESHING_DASHBOARD]: setRefreshingDashboard,
  [SET_ARCOS]: setArcos,
};

export default (state = initialState, action) => {
  const handler = ACTION_HANDLER[action.type];
  return handler ? handler(state, action.payload) : state;
};
